import api from '../api.js';

export const projectionRequests = {
  getByMonthAndYear: (month, year, type) => {
    return api.get(`/projections/filter?month=${month}&year=${year}&type=${type}`, { cache: 'no-store' });
  },
  getById: (id) => {
    return api.get(`/projections/${id}`, { cache: 'no-store' });
  },
  create: (projectionDto) => {
    return api.post(`/projections`, projectionDto);
  },
  update: (projectionDto, id) => {
    return api.put(`/projections/${id}`, projectionDto);
  },
  delete: (id) => {
    return api.delete(`/projections/${id}`);
  },
};

export default projectionRequests;
